import {language} from "./text/text";

export const alllanguage = language

export enum lanAssetConfig {
}